<template>
	<div ref="percentSlider" id="slider_loadShift_percent">
		<div ref="curveContainer" class="curve-container">
			<object
				ref="curveMask"
				class="expocurve mask"
				tabindex="-1"
				type="image/svg+xml"
				data="/static/build/gfx/expo_curve-mask.svg"
			/>
			<object
				class="expocurve"
				tabindex="-1"
				type="image/svg+xml"
				data="/static/build/gfx/expo_curve.svg"
			/>
			<object
				class="expocurve-label"
				tabindex="-1"
				type="image/svg+xml"
				data="/static/build/gfx/expo_curve-label.svg"
			/>
		</div>
	</div>
</template>

<script>
import noUiSlider from 'nouislider'

export default {
	name: 'LSPercentSlider',

	props: {
		value: Number,
		onUpdate: Function,
		disabled: {
			type: Boolean,
			default: true
		}
	},

	mounted() {
		const { $refs: { percentSlider, curveMask }, value, onUpdate, disabled } = this

		// Create slider without the connect line
		noUiSlider.create(percentSlider, {
			range: { min: 25, max: 100 },
			step: 1,
			start: [value],
			connect: false,
			behaviour: 'tap-drag',
			tooltips: true,
			pips: {
				mode: 'values',
				values: [25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100],
				density: 10,
				filter: val => [25, 100].includes(val) ? 1 : 2
			},
			format: { to: Math.floor, from: Math.floor }
		})

		// Set initial clip position and opacity
		const clipPos = 100 - Math.ceil((value - 25) * 1.3333)
		const opacity = Math.ceil((value - 25) * 1.3333) / 100
		curveMask.style.clipPath = `inset(0 ${clipPos}% 0 0)`
		curveMask.style.opacity = opacity

		// Start with grey curve if disabled
		if (disabled) {
			percentSlider.setAttribute('disabled', true)
			curveMask.style.filter = 'grayscale(100%)'
		}

		// Update curve on slider change
		percentSlider.noUiSlider.on('update', ([newVal]) => {
			onUpdate(newVal)

			const newClipPos = 100 - Math.ceil((newVal - 25) * 1.3333)
			const newOpacity = Math.ceil((newVal - 25) * 1.3333) / 100
			curveMask.style.clipPath = `inset(0 ${newClipPos}% 0 0)`
			curveMask.style.opacity = newOpacity
		})
	},

	watch: {
		disabled(newVal) {
			const { $refs: { percentSlider, curveMask } } = this
			if (percentSlider && percentSlider.noUiSlider) {
				if (newVal) {
					percentSlider.setAttribute('disabled', true)
					if (curveMask) curveMask.style.filter = 'grayscale(100%)'
				} else {
					percentSlider.removeAttribute('disabled')
					if (curveMask) curveMask.style.filter = ''
				}
			}
		},

		value(newVal) {
			const { $refs: { percentSlider } } = this
			if (percentSlider && percentSlider.noUiSlider && percentSlider.noUiSlider.get() != newVal) {
				percentSlider.noUiSlider.set(newVal)
			}
		}
	}
}

</script>

<style>
#slider_loadShift_percent .curve-container {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 4px;
	z-index: -1;
	pointer-events: none;
}

#slider_loadShift_percent .curve-container .expocurve {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	opacity: 0.5;
}

#slider_loadShift_percent .curve-container .expocurve.mask {
	opacity: 1;
}

#slider_loadShift_percent .curve-container .expocurve-label {
	position: absolute;
	bottom: 146px;
	right: -48px;
}
</style>
